module.exports = "pegasus/assets/theme3/l_w.png";